import Vue from "vue";
import _ from "lodash";

export default Vue.extend({
  computed: {
    currentBreadcrumbs(): object[] | null {
      const breadcrumbKeys = Object.keys(this.$route.query).filter(k => k.startsWith('bc['));
      if (breadcrumbKeys.length > 0) {
        const bc = [];
        for (const k of breadcrumbKeys) {
          _.set(bc, k.substring(2), this.$route.query[k]);
        }
        return bc;
      } else {
        return null;
      }
    },
  },
});